module.exports = __webpack_public_path__ + "static/media/hamburger-dark.e130cc03.svg";